import { Link } from "react-router-dom";
import ChangeTheme from "./ChangeTheme";

const Navbar = () => {
  const handleToggle = () => {
    let navLinks = document.querySelector(".nav-links");
    navLinks.classList.toggle("active");
  };

  return (
    <header>
      <nav>
        <div>
          <a className="brand-name" href="#top">
            Adeyemi Writes
          </a>
        </div>
        <p className="nav-toggler" onClick={handleToggle}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </p>
        <div className="nav-links">
          <ul>
            <li>
              <Link className="react-anchor" to="/">
                Home
              </Link>
            </li>
            <li>
              <Link className="react-anchor" to="/library">
                Library
              </Link>
            </li>
            <li>
              <Link className="react-anchor" to="/collabs">
                Collaborations
              </Link>
            </li>
            <li>
              <span>
                <ChangeTheme />
              </span>
            </li>
          </ul>
        </div>
      </nav>
      <hr />
    </header>
  );
};

export default Navbar;
